import { render, staticRenderFns } from "./ChannelPanel.vue?vue&type=template&id=0fb29fe7&scoped=true"
import script from "./ChannelPanel.vue?vue&type=script&lang=js"
export * from "./ChannelPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb29fe7",
  null
  
)

export default component.exports